import { ADMIN_CREDENTIALS, SESSION_KEY } from "@/config/adminCredentials";
import { supabase } from "@/integrations/supabase/client";

export const adminAuth = {
  login(email: string, password: string): boolean {
    if (email === ADMIN_CREDENTIALS.email && password === ADMIN_CREDENTIALS.password) {
      localStorage.setItem(SESSION_KEY, "authenticated");
      return true;
    }
    return false;
  },

  logout(): void {
    localStorage.removeItem(SESSION_KEY);
  },

  isAuthenticated(): boolean {
    return localStorage.getItem(SESSION_KEY) === "authenticated";
  },

  // Check if user has admin role in Supabase (for future compatibility)
  async checkSupabaseAdmin(userId: string): Promise<boolean> {
    try {
      const { data } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .eq("role", "admin")
        .maybeSingle();
      
      return !!data;
    } catch (error) {
      console.error("Error checking admin role:", error);
      return false;
    }
  },
};
